import ErxAdvices from "./ErxAdvices";
import ErxReferels from "./ErxReferels";
import OtherAttachment from "./OtherAttachment";
import {
  ErxAdviceContext,
  ErxAdviceDispatchContext,
} from "../../context/ErxContext";
import { erxProps } from "../../shared/data";
export default function AdviceContainer({
  otherAttachmentProps,
  extraData,
  newEntryForm,
  extraReferences,
  idSuffix,
  adviceContext,
  dispatchContext,
}) {
  return (
    <>
      <ErxAdviceContext.Provider value={adviceContext}>
        <ErxAdviceDispatchContext.Provider value={dispatchContext}>
          {erxProps.map((props, index) => {
            return (
              <ErxAdvices
                key={index}
                {...props}
                extraData={extraData}
                newEntryForm={newEntryForm}
                extraReferences={extraReferences}
                id={props.id + idSuffix}
              />
            );
          })}

          <ErxReferels newEntryForm={newEntryForm} id={`referels${idSuffix}`} />
          <OtherAttachment
            adviceSubmitUrl={
              process.env.REACT_APP_API_ENDPOINT + "/patient/new-advice/"
            }
            extraReferences={extraReferences}
            extraData={extraData}
            newEntryForm={newEntryForm}
            id={`otherAttachments${idSuffix}`}
          />
        </ErxAdviceDispatchContext.Provider>
      </ErxAdviceContext.Provider>
    </>
  );
}
